import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Distribution, DistributionDataI, Stock } from '../../shared/model';
import { DatabaseConnection } from '../../shared/services/database-connection';


@Injectable({
  providedIn: 'root',
})
export class StockService {

  private end_url = "stock"
  constructor(
    private http : HttpClient,
    private  dbConnection : DatabaseConnection
  ){

  }

  listStockBySite(){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + this.end_url)
  }

  siteStockDetails(site_id : string){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + this.end_url +"/"+ site_id + "/edit")
  }

  getDocuments(site_id : string){
    return this.http.get<DistributionDataI>(this.dbConnection.remoteApiConnection.value + this.end_url + "/"+ site_id)
  }

  create(data : any){
    return this.http.post<Stock>(this.dbConnection.remoteApiConnection.value + this.end_url, {stocks : data})
  }

  delete(site : string){
     return this.http.delete<any>(this.dbConnection.remoteApiConnection.value + this.end_url+"/"+site)
  }
}
